import { ActivatedRoute } from '@angular/router';
import { Component, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { NavController, MenuController } from '@ionic/angular';
import { ResetUser } from './resetPassword.interface';
import { Utils } from '../../service/utils';
import { ResetPasswordProvider } from './resetPassword.service';

const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])/;

@Component({
  selector: 'page-reset-password',
  templateUrl: 'resetPassword.html',
  providers: [ResetPasswordProvider],
  styleUrls: ['resetPassword.scss']
})
export class ResetPasswordPage {
  resetPassword: FormGroup;
  id: string;
  token: string;
  isApp: boolean;
  isSubmitted: boolean;
  isLoading: boolean;
  errorMessage: string;
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.onResize();
  }
  constructor(
    public navCtrl: NavController,
    public actRoute: ActivatedRoute,
    public menu: MenuController,
    private formBuilder: FormBuilder,
    public utils: Utils,
    public ResetPassword: ResetPasswordProvider,
    public dialog: MatDialog
  ) {
    this.resetPassword = this.formBuilder.group(
      {
        password: new FormControl('', [
          Validators.required,
          Validators.pattern(PASSWORD_REGEX),
          Validators.minLength(8)
        ]),
        confirmPassword: new FormControl('', [
          Validators.required,
          Validators.pattern(PASSWORD_REGEX),
          Validators.minLength(8)
        ])
      },
      { validator: this.matchPasswordCheck }
    );

    this.errorMessage = '';
    this.menu.enable(false);
    this.isSubmitted = false;
    this.isLoading = false;
    this.onResize(); // determine if its the app using ionic
  }

  matchPasswordCheck = (control: AbstractControl): { [key: string]: boolean } => {
    const newPassword = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    // Don't kick in until user touches both fields
    if (newPassword.pristine || confirmPassword.pristine) {
      return null;
    }

    if (!newPassword || !confirmPassword) {
      return null;
    }

    return newPassword.value === confirmPassword.value ? null : { matchPasswordCheck: true };
  };

  onResize = () => {
    this.isApp = this.utils.isApp();
  };

  onSubmit = ({ value, valid }: { value: ResetUser; valid: boolean }) => {
    this.errorMessage = '';
    this.isLoading = true;

    value.id = this.actRoute.snapshot.params['id'];
    value.token = this.actRoute.snapshot.params['token'];

    this.ResetPassword.resetPassword(value).subscribe(
      response => {
        //response has access token
        this.isSubmitted = false;
        this.isLoading = false;

        this.utils.openDialog(
          {
            title: 'Success',
            message: 'Your password has been updated. Return to Login?'
          },
          'confirm',
          () => {
            this.navCtrl.navigateForward('/login');
          }
        );
      },
      error => {
        this.isLoading = false;
        this.errorMessage = error;
      }
    );
  };

  ngOnInit = () => {
    console.log('ionViewDidLoad ShowPage');
  };
}
